import React, { useState } from 'react'
import { Marker } from 'types/markers'
import { LngLat } from 'mapbox-gl'

export function AdminMarkersList({
  markers,
  suffix,
  countLabel,
  noMarkersMessage,
  adminUsername,
  handlePanTo,
  handleDisable,
  handleDelete
}: {
  markers: Marker[]
  suffix: string
  countLabel: string
  noMarkersMessage: string
  adminUsername: string
  handlePanTo: (target: LngLat) => void
  handleDisable: (markerId: string, adminUsername: string) => void
  handleDelete: (markerId: string) => void
}) {
  const [showTdg, setShowTdg] = useState(true)
  const [showVqh, setShowVqh] = useState(true)

  const filterMarkers = (markerList: Marker[]) => {
    return markerList.filter(marker => {
      if (!showTdg && !showVqh) {
        return false
      } else if (!showTdg) {
        // exclude legacy tdg markers
        return marker.publication === '24heures'
      } else if (!showVqh) {
        return marker.publication !== '24heures'
      } else {
        return true
      }
    })
  }

  return (
    <div className='ui container'>
      {markers.length > 0 ? (
        <div className='ui clearing segment'>
          <h5 className='ui header'>
            {filterMarkers(markers).length} {countLabel}
          </h5>

          <div className='ui form'>
            <div className='inline fields'>
              <div className='ui field'>
                <div className='ui checkbox'>
                  <input
                    type='checkbox'
                    name='tdgFilter'
                    id={'tdgFilter_' + suffix}
                    onChange={() => {
                      setShowTdg(!showTdg)
                    }}
                    checked={showTdg}
                  />
                  <label htmlFor={'tdgFilter_' + suffix}>tdg.ch</label>
                </div>
              </div>

              <div className='ui field'>
                <div className='ui checkbox'>
                  <input
                    type='checkbox'
                    name='vqhFilter'
                    id={'vqhFilter_' + suffix}
                    onChange={() => {
                      setShowVqh(!showVqh)
                    }}
                    checked={showVqh}
                  />
                  <label htmlFor={'vqhFilter_' + suffix}>24heures.ch</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {markers.length > 0 ? (
        <div className='ui three cards'>
          {filterMarkers(markers).map(marker => (
            <div
              className={
                'card ' + (marker.publication ? marker.publication : '')
              }
              key={'flagged_' + marker.markerId}
            >
              <div className='content'>
                <div className='header'>{marker.title} </div>
                <div className='description'>
                  {marker.description ? marker.description.substr(0, 50) : ''}…
                </div>
              </div>
              <div className='extra content'>
                <div className='ui three buttons small'>
                  <button
                    className='ui button'
                    onClick={() => {
                      const target = new LngLat(
                        marker.longitude,
                        marker.latitude
                      )
                      handlePanTo(target)
                    }}
                  >
                    Y aller
                  </button>
                  {suffix === 'flagged' && (
                    <>
                      <button
                        className='ui button orange'
                        onClick={() => {
                          if (
                            confirm(
                              'Désactiver le marqueur ' + marker.title + '?'
                            )
                          ) {
                            console.log('Disable', marker.markerId)
                            // updateMarker(marker.markerId, 'disable')
                            handleDisable(marker.markerId, adminUsername)
                          }
                        }}
                      >
                        Désactiver
                      </button>
                      <button
                        className='ui button red'
                        onClick={() => {
                          console.log('Delete', marker.markerId)
                          // updateMarker(marker.markerId, 'disable')
                          if (
                            confirm(
                              'Effacer le marqueur ' +
                                marker.title +
                                '(id: ' +
                                marker.markerId +
                                ')' +
                                '?'
                            )
                          ) {
                            console.log('Deleting marker', marker.markerId)
                            handleDelete(marker.markerId)
                          }
                        }}
                      >
                        Supprimer
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className='ui segment'>
          <p className='ui message'>{noMarkersMessage}</p>
        </div>
      )}
    </div>
  )
}
